const ENTITLEMENT_INFO_LABEL = 'graph_case_entitlement_info';

export const GRAPH_LABELS = {
  EAP_AKA_AUTH: 'graph_case_new_eap_aka_challenge',
  EAP_AKA_VALIDATION: 'graph_case_eap_aka_validation',
  AUTH_SUCCESS: 'graph_case_new_eap_aka_challenge',
  PHONE_NUM_INFO: 'graph_case_get_phone_info',
  ENTITLEMENT_INFO: ENTITLEMENT_INFO_LABEL,
  ENTITLEMENTS_DT: 'graph_case_entitlement_info_transfer',
  ESIM_VALIDATE: 'graph_case_preflight_security_check',
  ESIM_VALIDATE_SUCCESS: 'graph_case_preflight_security_check',
  WEBSHEET_ESIM_TRANSFER: 'graph_case_websheet_redirect',
  WEBSHEET_ESIM_TRANSFER_SUCCESS: 'graph_case_websheet_redirect',
  ESIM_TRANSFER_TYPE_SUCCESS_WEBSHEET: 'graph_case_preflight_check',
  ESIM_TRANSFER_TYPE: 'graph_case_preflight_check',
  ESIM_TRANSFER_TYPE_SUCCESS: 'graph_case_preflight_check',
  ESIM_ORDER: 'graph_case_order_esim',
  ESIM_ORDER_SUCCESS: 'graph_case_order_esim',
  SIM_SWAP: 'graph_case_sim_swap',
  SIM_SWAP_SUCCESS: 'graph_case_sim_swap',
  ESIM_RELEASE: 'graph_case_release_esim',
  ESIM_RELEASE_SUCCESS: 'graph_case_release_esim',
  ROAMING_INFO: 'graph_case_roaming_info',
  ROAMING_NETWORKS_INFO: 'graph_case_roaming_info',
  PROVISION_VOLTE: 'graph_case_provision_volte',
  ACTIVATE_VOLTE_SUCCESS: 'graph_case_provision_volte',
  ENTITLEMENTS_FIVE_G_ENABLED: ENTITLEMENT_INFO_LABEL,
  ENTITLEMENTS_VOLTE_DISABLED: ENTITLEMENT_INFO_LABEL,
  ENTITLEMENTS_VOWIFI_DISABLED: ENTITLEMENT_INFO_LABEL,
  MULTI_SIM_TRANSFER_ENABLED: 'graph_case_entitlement_info_multi_sim',
  VOWIFI_PROVISION: ENTITLEMENT_INFO_LABEL,
  DEPROVISION_VOLTE: 'graph_case_deprovision_volte',
  WIFI_STATUS_INFO: 'graph_case_wifi_status_info',
  PROVISION_VOWIFI: 'graph_case_provision_vowifi',
  DEPROVISION_VOWIFI: 'graph_case_deprovision_vowifi',
  FIVE_G_PLAN_INFO: 'graph_case_5g_plan_info',
  PROVISION_SUBSCRIPTION: 'graph_case_provision_subscription',
  PLAN_OFFERS: 'graph_case_plan_offers',
  PLAN_OFFERS_INFO_FAILURE: 'graph_case_plan_offers',
  DEPROVISION_SUBSCRIPTION_SUCCESS: 'graph_case_deprovision_subscription',
  CHANGE_SUBSCRIPTION_SUCCESS: 'graph_case_change_subscription',
  ESIM_RELEASE_DELAYED_DOWNLOAD_SUCCESS: 'graph_case_release_esim',
  PUSH_MESSAGE_SUCCESS: 'graph_case_push_message',
  WEBSHEET_WATCH_ACTIVATION_SUCCESS: 'graph_case_websheet_redirect',
  SIM_STATUS: 'graph_case_sim_status',
  SIM_STATUS_SUCCESS: 'graph_case_sim_status',
  SIM_STATUS_TOO_MANY_DEVICES_SUCCESS: 'graph_case_sim_status',
  DT_FULL_PSIM_TO_ESIM: 'graph_case_dt_full_psim_to_esim',
  DT_FULL_ESIM_TO_ESIM: 'graph_case_dt_full_esim_to_esim',
  DT_FULL_CONVERSION: 'graph_case_dt_full_conversion',
  DT_FULL_WEB_SHEET_ESIM_TO_ESIM: 'graph_case_dt_full_web_sheet_esim_to_esim',
  DT_FULL_WEB_SHEET_PSIM_TO_ESIM: 'graph_case_dt_full_web_sheet_psim_to_esim',
  DT_FULL_WEB_SHEET_CONVERSION: 'graph_case_dt_full_web_sheet_conversion',
  DT_FULL_PSIM_TO_ESIM_ANDROID: 'graph_case_dt_full_psim_to_esim_android',
  DT_FULL_ESIM_TO_ESIM_ANDROID: 'graph_case_dt_full_esim_to_esim_android',
  DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID:
    'graph_case_dt_full_web_sheet_psim_to_esim_android',
  DT_FULL_WEB_SHEET_ESIM_TO_ESIM_ANDROID:
    'graph_case_dt_full_web_sheet_esim_to_esim_android',
  WEBSHEET_ESIM_TRANSFER_DIRECT: 'graph_case_websheet_redirect',
  WEBSHEET_ESIM_TRANSFER_DIRECT_SUCCESS: 'graph_case_websheet_redirect',
  PUSH_MESSAGE: 'graph_case_push_message',
  TRANSFER: 'graph_case_transfer',
  CONFIRM_TRANSFER: 'graph_case_confirm_transfer',
  CARRIER_AUTHENTICATION_OTP: 'graph_case_otp_request',
  CARRIER_AUTH_OTP_SUCCESS: 'graph_case_otp_request',
  CARRIER_AUTH_OTP_FAILURE: 'graph_case_otp_request',
  CARRIER_AUTHENTICATION_OTP_VALIDATE: 'graph_case_otp_validation',
  CARRIER_AUTH_OTP_VALIDATE_SUCCESS: 'graph_case_otp_validation',
  CARRIER_AUTH_OTP_VALIDATE_FAILURE: 'graph_case_otp_validation',
  PLAN_OFFERS_INFO_SUCCESS: 'graph_case_plan_offers',
  ESIM_TRANSFER_TYPE_SUCCESS_ONE_CLICK: 'graph_case_preflight_check',
  PROVISION_SUBSCRIPTION_SUCCESS: 'graph_case_provision_subscription',
};

export const GRAPH_HEADERS: any = {
  DEFAULT: [
    'graph_header_device',
    'graph_header_entitlement_server',
    'graph_header_oss_bss',
  ],
  TARGET_SOURCE: [
    'graph_header_source_device',
    'graph_header_target_device',
    'graph_header_entitlement_server',
    'graph_header_oss_bss',
  ],
} as const;

GRAPH_HEADERS.DEVICE_TRANSFER_FULL = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DEVICE_TRANSFER_FULL_WEB_SHEET = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DEVICE_TRANSFER_WEB_SHEET = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_PSIM_TO_ESIM = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_ESIM_TO_ESIM = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.IPAD_ACTIVATION_SUCCESS = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_ACTIVATION_SUCCESS = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_ACTIVATION_SUCCESS_ANDROID = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_ACTIVATION_MAX_NO_DEVICES = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_ACTIVATION_MAX_NO_DEVICES_ANDROID =
  GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_ACTIVATION_WRONG_PLAN = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_ACTIVATION_WRONG_PLAN_ANDROID = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_MANAGE_SUCCESS = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_MANAGE_SUCCESS_ANDROID = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_TRANSFER_SUCCESS = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.WATCH_TRANSFER_WEBSHEET_SUCCESS = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_CONVERSION = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_WEB_SHEET_ESIM_TO_ESIM = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_WEB_SHEET_PSIM_TO_ESIM = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_WEB_SHEET_CONVERSION = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_PSIM_TO_ESIM_ANDROID = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_ESIM_TO_ESIM_ANDROID = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID =
  GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID =
  GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_FULL_WEB_SHEET_ESIM_TO_ESIM_ANDROID =
  GRAPH_HEADERS.TARGET_SOURCE;

GRAPH_HEADERS.DT_ONE_CLICK_TC = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_ONE_CLICK_OTP = GRAPH_HEADERS.TARGET_SOURCE;
GRAPH_HEADERS.DT_ONE_CLICK_TC_OTP = GRAPH_HEADERS.TARGET_SOURCE;

GRAPH_HEADERS.PHONE_NUMBER_REGISTRATION = GRAPH_HEADERS.DEFAULT;
GRAPH_HEADERS.ROAMING_LIST = GRAPH_HEADERS.DEFAULT;
GRAPH_HEADERS.ENTITLEMENTS_INFO = GRAPH_HEADERS.DEFAULT;
GRAPH_HEADERS.VOLTE_PROVISION = GRAPH_HEADERS.DEFAULT;
GRAPH_HEADERS.VOLTE_DEPROVISION = GRAPH_HEADERS.DEFAULT;
GRAPH_HEADERS.FIVE_G_TESTCASE = GRAPH_HEADERS.DEFAULT;
GRAPH_HEADERS.VOWIFI_DEPROVISION = GRAPH_HEADERS.DEFAULT;
GRAPH_HEADERS.VOWIFI_PROVISION = GRAPH_HEADERS.DEFAULT;

export const GRAPH_CASES: any = {
  DEVICE_PLAN_OFFER_BASE: [
    {
      label: 'graph_case_eap_aka_device_auth',
      start: 'graph_header_source_device',
      end: 'graph_header_entitlement_server',
      row: 1,
    },
    {
      label: 'graph_case_new_eap_aka_challenge',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 1,
    },
    {
      label: 'graph_case_eap_aka_validation',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 2,
    },
    {
      label: 'graph_case_entitlement_info',
      start: 'graph_header_source_device',
      end: 'graph_header_entitlement_server',
      row: 3,
    },
    {
      label: 'graph_case_sim_status',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 4,
    },
  ],
  DEVICE_TRANSFER_BASE: [
    {
      label: 'graph_case_eap_aka_device_auth',
      start: 'graph_header_source_device',
      end: 'graph_header_entitlement_server',
      row: 1,
    },
    {
      label: 'graph_case_new_eap_aka_challenge',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 1,
    },
    {
      label: 'graph_case_eap_aka_validation',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 2,
    },
    {
      label: 'graph_case_entitlement_info',
      start: 'graph_header_source_device',
      end: 'graph_header_entitlement_server',
      row: 3,
    },
    {
      label: 'graph_case_entitlement_info_transfer',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 3,
    },
    {
      label: 'graph_case_initiate_esim',
      start: 'graph_header_target_device',
      end: 'graph_header_entitlement_server',
      row: 4,
    },
    {
      label: 'graph_case_preflight_check',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 4,
    },
    {
      label: 'graph_case_preflight_security_check',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 5,
    },
  ],
  DEFAULT: [
    {
      label: 'graph_case_eap_aka_device_auth',
      start: 'graph_header_device',
      end: 'graph_header_entitlement_server',
      row: 1,
    },
    {
      label: 'graph_case_new_eap_aka_challenge',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 1,
    },
    {
      label: 'graph_case_eap_aka_validation',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: 2,
    },
  ],
} as const;

GRAPH_CASES.DEVICE_TRANSFER_FULL = [
  ...GRAPH_CASES.DEVICE_TRANSFER_BASE,
  {
    label: 'graph_case_order_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 6,
  },
  {
    label: 'graph_case_sim_swap',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 7,
  },
  {
    label: 'graph_case_release_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 8,
  },
  {
    label: 'graph_case_activate_esim',
    start: 'graph_header_target_device',
    end: 5,
    row: 9,
  },
];

GRAPH_CASES.DEVICE_TRANSFER_FULL_WEB_SHEET = [
  ...GRAPH_CASES.DEVICE_TRANSFER_BASE,
  {
    label: 'graph_case_websheet_redirect',
    start: 'graph_header_target_device',
    end: 'graph_header_entitlement_server',
    row: 6,
  },
  {
    label: 'graph_case_optional_carrier_auth',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 6,
  },
  {
    label: 'graph_case_order_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 7,
  },
  {
    label: 'graph_case_sim_swap',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 8,
  },
  {
    label: 'graph_case_release_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 9,
  },
  {
    label: 'graph_case_activate_esim',
    start: 'graph_header_target_device',
    end: 5,
    row: 10,
  },
];

GRAPH_CASES.DEVICE_TRANSFER_WEB_SHEET_ANDROID = [
  ...GRAPH_CASES.DEVICE_TRANSFER_BASE,
  {
    label: 'graph_case_websheet_redirect',
    start: 'graph_header_target_device',
    end: 'graph_header_entitlement_server',
    row: 6,
  },
  {
    label: 'graph_case_optional_carrier_auth',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 6,
  },
  {
    label: 'graph_case_entitlement_info_transfer',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 7,
  },
  {
    label: 'graph_case_order_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 8,
  },
  {
    label: 'graph_case_sim_swap',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 9,
  },
  {
    label: 'graph_case_release_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 10,
  },
  {
    label: 'graph_case_activate_esim',
    start: 'graph_header_target_device',
    end: 5,
    row: 11,
  },
];
GRAPH_CASES.DEVICE_PLAN_OFFER_DEFAULT = [
  {
    label: 'graph_case_plan_offers',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 5,
  },
  {
    label: 'graph_case_order_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 6,
  },
  {
    label: 'graph_case_provision_subscription',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 7,
  },
  {
    label: 'graph_case_release_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 8,
  },
  {
    label: 'graph_case_download_esim',
    start: 'graph_header_source_device',
    end: 4,
    row: 9,
  },
];
GRAPH_CASES.DEVICE_PLAN_OFFER_WATCH = [
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_BASE,
  {
    label: 'graph_case_entitlement_info_multi_sim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_DEFAULT,
];

GRAPH_CASES.DEVICE_PLAN_OFFER_IPAD = [
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_BASE,
  {
    label: 'graph_case_entitlement_info_ipad_sign_up',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_DEFAULT,
];

GRAPH_CASES.DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID =
  GRAPH_CASES.DEVICE_TRANSFER_WEB_SHEET_ANDROID;

GRAPH_CASES.DT_FULL_WEB_SHEET_ESIM_TO_ESIM_ANDROID =
  GRAPH_CASES.DEVICE_TRANSFER_WEB_SHEET_ANDROID;

GRAPH_CASES.DEVICE_TRANSFER_WEB_SHEET =
  GRAPH_CASES.DEVICE_TRANSFER_FULL_WEB_SHEET;

GRAPH_CASES.PHONE_NUMBER_REGISTRATION = [
  ...GRAPH_CASES.DEFAULT,
  {
    label: 'graph_case_get_phone_info',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 3,
  },
  {
    label: 'graph_case_get_phone_info',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
];

GRAPH_CASES.ROAMING_LIST = [
  ...GRAPH_CASES.DEFAULT,
  {
    label: 'graph_case_roaming_info',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 3,
  },
  {
    label: 'graph_case_roaming_info',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
];

GRAPH_CASES.ENTITLEMENTS_INFO = [
  ...GRAPH_CASES.DEFAULT,
  {
    label: 'graph_case_entitlement_info',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 3,
  },
  {
    label: 'graph_case_entitlement_info',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
];

GRAPH_CASES.VOLTE_PROVISION = [
  ...GRAPH_CASES.ENTITLEMENTS_INFO,
  {
    label: 'graph_case_provision_volte',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 4,
  },
  {
    label: 'graph_case_provision_volte',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 4,
  },
];

GRAPH_CASES.VOLTE_DEPROVISION = [
  ...GRAPH_CASES.ENTITLEMENTS_INFO,
  {
    label: 'graph_case_deprovision_volte',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 4,
  },
  {
    label: 'graph_case_deprovision_volte',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 4,
  },
];

GRAPH_CASES.VOWIFI_PROVISION = [
  ...GRAPH_CASES.ENTITLEMENTS_INFO,
  {
    label: 'graph_case_wifi_status_info',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 4,
  },
  {
    label: 'graph_case_wifi_status_info',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 4,
  },
  {
    label: 'graph_case_provision_vowifi',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 5,
  },
  {
    label: 'graph_case_provision_vowifi',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 5,
  },
];

GRAPH_CASES.VOWIFI_DEPROVISION = [
  ...GRAPH_CASES.ENTITLEMENTS_INFO,
  {
    label: 'graph_case_deprovision_vowifi',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 4,
  },
  {
    label: 'graph_case_deprovision_vowifi',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 4,
  },
];

GRAPH_CASES.FIVE_G_TESTCASE = [
  ...GRAPH_CASES.ENTITLEMENTS_INFO,
  {
    label: 'graph_case_5g_plan_info',
    start: 'graph_header_device',
    end: 'graph_header_entitlement_server',
    row: 4,
  },
  {
    label: 'graph_case_5g_plan_info',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 4,
  },
];

GRAPH_CASES.DT_FULL_PSIM_TO_ESIM = GRAPH_CASES.DEVICE_TRANSFER_FULL;
GRAPH_CASES.DT_FULL_ESIM_TO_ESIM = GRAPH_CASES.DEVICE_TRANSFER_FULL;
GRAPH_CASES.DT_FULL_ESIM_TO_ESIM = GRAPH_CASES.DEVICE_TRANSFER_FULL;
GRAPH_CASES.DT_FULL_CONVERSION = GRAPH_CASES.DEVICE_TRANSFER_FULL;
GRAPH_CASES.WATCH_ACTIVATION_SUCCESS = [
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_WATCH,
  {
    label: 'graph_case_install_esim_on_watch',
    start: 'graph_header_source_device',
    end: 2,
    row: 10,
  },
];
GRAPH_CASES.WATCH_ACTIVATION_SUCCESS_ANDROID =
  GRAPH_CASES.WATCH_ACTIVATION_SUCCESS;
GRAPH_CASES.WATCH_ACTIVATION_MAX_NO_DEVICES = [
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_BASE,
  {
    label: 'graph_case_entitlement_info_multi_sim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
  {
    label: 'graph_case_plan_offers',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 5,
  },
];
GRAPH_CASES.WATCH_ACTIVATION_MAX_NO_DEVICES_ANDROID =
  GRAPH_CASES.WATCH_ACTIVATION_MAX_NO_DEVICES;

// Wrong-plan negative tests run the same flow as max-no-devices: the plan
// offers step is where the rejection surfaces.
GRAPH_CASES.WATCH_ACTIVATION_WRONG_PLAN =
  GRAPH_CASES.WATCH_ACTIVATION_MAX_NO_DEVICES;
GRAPH_CASES.WATCH_ACTIVATION_WRONG_PLAN_ANDROID =
  GRAPH_CASES.WATCH_ACTIVATION_MAX_NO_DEVICES;

GRAPH_CASES.WATCH_MANAGE_SUCCESS = [
  ...GRAPH_CASES.WATCH_ACTIVATION_MAX_NO_DEVICES,
  {
    label: 'graph_case_deprovision_subscription',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 6,
  },
  {
    label: 'graph_case_change_subscription',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 7,
  },
];
GRAPH_CASES.WATCH_MANAGE_SUCCESS_ANDROID = GRAPH_CASES.WATCH_MANAGE_SUCCESS;

// Watch transfer flow: order → add plan → SIM swap → release, per the
// backend test-case steps (usecase_tc/watch.py).
const WATCH_TRANSFER_STEPS = (firstRow: number) => [
  {
    label: 'graph_case_plan_offers',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: firstRow,
  },
  {
    label: 'graph_case_order_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: firstRow + 1,
  },
  {
    label: 'graph_case_provision_subscription',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: firstRow + 2,
  },
  {
    label: 'graph_case_sim_swap',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: firstRow + 3,
  },
  {
    label: 'graph_case_release_esim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: firstRow + 4,
  },
  {
    label: 'graph_case_install_esim_on_watch',
    start: 'graph_header_source_device',
    end: 2,
    row: firstRow + 5,
  },
];

GRAPH_CASES.WATCH_TRANSFER_SUCCESS = [
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_BASE,
  {
    label: 'graph_case_entitlement_info_multi_sim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
  ...WATCH_TRANSFER_STEPS(5),
];

GRAPH_CASES.WATCH_TRANSFER_WEBSHEET_SUCCESS = [
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_BASE,
  {
    label: 'graph_case_entitlement_info_multi_sim',
    type: 'primary',
    start: 'graph_header_entitlement_server',
    end: 'graph_header_oss_bss',
    row: 3,
  },
  {
    label: 'graph_case_websheet_redirect',
    start: 'graph_header_target_device',
    end: 'graph_header_entitlement_server',
    row: 5,
  },
  ...WATCH_TRANSFER_STEPS(6),
];
GRAPH_CASES.IPAD_ACTIVATION_SUCCESS = [
  ...GRAPH_CASES.DEVICE_PLAN_OFFER_IPAD,
  {
    label: 'graph_case_install_esim_on_iPad',
    start: 'graph_header_source_device',
    end: 2,
    row: 10,
  },
];

GRAPH_CASES.DT_FULL_ESIM_TO_ESIM_ANDROID = GRAPH_CASES.DEVICE_TRANSFER_FULL;

GRAPH_CASES.DT_FULL_PSIM_TO_ESIM_ANDROID = GRAPH_CASES.DEVICE_TRANSFER_FULL;

GRAPH_CASES.DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID =
  GRAPH_CASES.DEVICE_TRANSFER_FULL_WEB_SHEET;

GRAPH_CASES.DT_FULL_WEB_SHEET_ESIM_TO_ESIM =
  GRAPH_CASES.DEVICE_TRANSFER_FULL_WEB_SHEET;
GRAPH_CASES.DT_FULL_WEB_SHEET_PSIM_TO_ESIM =
  GRAPH_CASES.DEVICE_TRANSFER_FULL_WEB_SHEET;
GRAPH_CASES.DT_FULL_WEB_SHEET_CONVERSION =
  GRAPH_CASES.DEVICE_TRANSFER_FULL_WEB_SHEET;

const ONE_CLICK_TC_STEP = (row: number) => {
  return {
    label: 'graph_case_one_click_tc',
    start: 'graph_header_target_device',
    end: 'graph_header_entitlement_server',
    row,
  };
};

const ONE_CLICK_OTP_STEPS = (firstRow: number) => {
  return [
    {
      label: 'graph_case_retrieve_otp',
      start: 'graph_header_target_device',
      end: 'graph_header_entitlement_server',
      row: firstRow,
    },
    {
      label: 'graph_case_otp_request',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: firstRow,
    },
    {
      label: 'graph_case_submit_otp',
      start: 'graph_header_target_device',
      end: 'graph_header_entitlement_server',
      row: firstRow + 1,
    },
    {
      label: 'graph_case_otp_validation',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: firstRow + 1,
    },
  ];
};

const ONE_CLICK_TRANSFER_TAIL = (firstRow: number) => {
  return [
    {
      label: 'graph_case_order_esim',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: firstRow,
    },
    {
      label: 'graph_case_sim_swap',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: firstRow + 1,
    },
    {
      label: 'graph_case_release_esim',
      type: 'primary',
      start: 'graph_header_entitlement_server',
      end: 'graph_header_oss_bss',
      row: firstRow + 2,
    },
    {
      label: 'graph_case_activate_esim',
      start: 'graph_header_target_device',
      end: 5,
      row: firstRow + 3,
    },
  ];
};

// The target device shows the T&Cs and handles the OTP after the source
// device's pre-flight security check and before the order, so a failed OTP
// must not grey out a security check that passed
// (whistler-es docs/charts_source/device_transfer_one_click_tc_otp.uml).
GRAPH_CASES.DT_ONE_CLICK_TC = [
  ...GRAPH_CASES.DEVICE_TRANSFER_BASE,
  ONE_CLICK_TC_STEP(6),
  ...ONE_CLICK_TRANSFER_TAIL(7),
];
GRAPH_CASES.DT_ONE_CLICK_OTP = [
  ...GRAPH_CASES.DEVICE_TRANSFER_BASE,
  ...ONE_CLICK_OTP_STEPS(6),
  ...ONE_CLICK_TRANSFER_TAIL(8),
];
GRAPH_CASES.DT_ONE_CLICK_TC_OTP = [
  ...GRAPH_CASES.DEVICE_TRANSFER_BASE,
  ONE_CLICK_TC_STEP(6),
  ...ONE_CLICK_OTP_STEPS(7),
  ...ONE_CLICK_TRANSFER_TAIL(9),
];
